// Carry Roll TrendsView — session history and trends over time (8.6).

import { useStore } from '../../store';
import { convertDistance } from '@carry-roll/shared-logic';

export function TrendsView() {
  const sessions = useStore((s) => s.sessions);
  const distanceUnit = useStore((s) => s.distanceUnit);

  if (sessions.length === 0) return null;

  const conv = (m: number) => convertDistance(m, distanceUnit);
  const points = sessions
    .filter((s) => s.avgCarryM != null)
    .map((s) => ({ name: s.name, carry: conv(s.avgCarryM as number) }));

  const carries = points.map((p) => p.carry);
  const dataMax = Math.max(...carries);
  const dataMin = Math.min(...carries);
  const range = dataMax - dataMin || 1;
  const padTop = dataMax + range * 0.15;
  const padBottom = Math.max(0, dataMin - range * 0.15);
  const scale = padTop - padBottom || 1;
  const step = points.length > 1 ? 260 / (points.length - 1) : 0;

  return (
    <div className="panel" data-testid="trends-view">
      <h3 className="subsection-title">
        Trends
      </h3>
      {points.length === 0 ? (
        <p className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
          Save shots to see carry trends.
        </p>
      ) : (
        <svg viewBox="0 0 300 120" width="100%" role="img" aria-label="Carry trend over sessions">
          <polyline
            fill="none"
            stroke="var(--color-carry)"
            strokeWidth={2}
            points={points
              .map((p, i) => `${20 + i * step},${100 - ((p.carry - padBottom) / scale) * 80}`)
              .join(' ')}
          />
          {points.map((p, i) => (
            <circle key={i} cx={20 + i * step} cy={100 - ((p.carry - padBottom) / scale) * 80} r={3} fill="var(--color-carry)" />
          ))}
        </svg>
      )}
    </div>
  );
}
